import { Link } from "react-router-dom";
import { categories } from "@/mocks/categories";

const siteLinks = [
  { to: "/", label: "首页" },
  { to: "/archives", label: "悬疑档案" },
  { to: "/about", label: "关于我们" },
  { to: "/faq", label: "常见问题" },
];

export default function SiteFooter() {
  return (
    <footer className="relative border-t border-background-800 bg-background-900">
      <div className="absolute inset-x-0 top-0 h-px bg-gradient-to-r from-transparent via-primary-500/60 to-transparent" />
      <div className="mx-auto w-full max-w-content px-4 py-12 md:px-6 md:py-16">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-2 lg:grid-cols-4">
          <div className="lg:col-span-1">
            <div className="flex items-center gap-2.5">
              <span className="flex h-9 w-9 items-center justify-center rounded-md border border-primary-500/50 bg-primary-500/10 text-primary-400">
                <i className="ri-eye-2-line text-lg" />
              </span>
              <span className="font-heading text-lg font-bold text-foreground-50">猎奇吃瓜</span>
            </div>
            <p className="mt-4 max-w-xs text-sm leading-relaxed text-foreground-400">
              把未解之谜、灵异杂谈与都市传说整理成可读的档案。我们不贩卖恐惧，只想让每个悬案都有一个体面的归档方式。
            </p>
            <p className="mt-4 flex items-center gap-2 text-sm text-foreground-400">
              <i className="ri-mail-line text-primary-400" />
              contact@lieqichigua.com
            </p>
          </div>

          <nav aria-label="档案分类">
            <h3 className="font-heading text-sm font-semibold tracking-wide text-foreground-100">档案分类</h3>
            <ul className="mt-4 space-y-2.5">
              {categories.map((category) => (
                <li key={category.slug}>
                  <Link
                    to={`/archives?category=${category.slug}`}
                    className="text-sm text-foreground-400 transition-colors hover:text-primary-300"
                  >
                    {category.name}
                  </Link>
                </li>
              ))}
            </ul>
          </nav>

          <nav aria-label="站点导航">
            <h3 className="font-heading text-sm font-semibold tracking-wide text-foreground-100">站点导航</h3>
            <ul className="mt-4 space-y-2.5">
              {siteLinks.map((link) => (
                <li key={link.to}>
                  <Link to={link.to} className="text-sm text-foreground-400 transition-colors hover:text-primary-300">
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </nav>

          <div>
            <h3 className="font-heading text-sm font-semibold tracking-wide text-foreground-100">档案说明</h3>
            <p className="mt-4 text-sm leading-relaxed text-foreground-400">
              站内内容多源自古籍、公开报道与读者口述整理，仅供参考与讨论，不作为事实结论。如涉及版权或隐私问题，欢迎来信说明。
            </p>
            <div className="mt-4 flex items-center gap-3">
              <span className="flex h-9 w-9 items-center justify-center rounded-md border border-background-700 text-foreground-400">
                <i className="ri-wechat-line" />
              </span>
              <span className="flex h-9 w-9 items-center justify-center rounded-md border border-background-700 text-foreground-400">
                <i className="ri-rss-line" />
              </span>
              <span className="flex h-9 w-9 items-center justify-center rounded-md border border-background-700 text-foreground-400">
                <i className="ri-mail-send-line" />
              </span>
            </div>
          </div>
        </div>

        <div className="mt-12 flex flex-col gap-3 border-t border-background-800 pt-6 text-xs text-foreground-500 sm:flex-row sm:items-center sm:justify-between">
          <p>© {new Date().getFullYear()} 猎奇吃瓜 · 保留所有权利</p>
          <p className="flex items-center gap-2">
            <i className="ri-shield-check-line" />
            内容由读者共建，欢迎提供线索与勘误
          </p>
        </div>
      </div>
    </footer>
  );
}